import MedicalRecordWaiverScene from './MedicalRecordWaiverScene';
export default MedicalRecordWaiverScene;